import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Layout, Typography, Space, Dropdown, Avatar } from 'antd';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { useUser } from '../context/UserContext';
import Sidebar from '../components/layout/Sidebar';

const { Header, Content, Footer } = Layout;
const { Title, Text } = Typography;

const GlobalLayout = () => {
  const navigate = useNavigate();
  const { user, logout } = useUser();
  const [collapsed, setCollapsed] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: 'Profile',
      onClick: () => {
        // TODO: Navigate to profile page
        console.log('Navigate to profile');
      }
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      onClick: handleLogout
    }
  ];

  return (
    <Layout className="global-layout" style={{ minHeight: '100vh' }}>
      <Sidebar collapsed={collapsed} onCollapse={() => setCollapsed(!collapsed)} />
      <Layout>
        <Header className="app-header" style={{ 
          background: '#fff', 
          padding: '0 24px',
          boxShadow: '0 1px 4px rgba(0,21,41,.08)'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '100%'
          }}>
            <Title level={3} style={{ color: '#1890ff', margin: 0 }}>
              OTT Dashboard
            </Title>

            <Space>
              <Text style={{ color: '#666' }}>
                Welcome, {user?.name || 'User'}
              </Text>
              <Dropdown
                menu={{ items: userMenuItems }}
                placement="bottomRight"
                arrow
              >
                <Avatar
                  icon={<UserOutlined />}
                  style={{ cursor: 'pointer' }}
                />
              </Dropdown>
            </Space>
          </div>
        </Header>
        <Content className="app-main" style={{ 
          margin: '24px 24px 0',
          minHeight: 'calc(100vh - 112px)'
        }}>
          <Outlet />
        </Content>
        <Footer className="app-footer" style={{ 
          textAlign: 'center',
          background: '#f0f2f5',
          padding: '12px 24px'
        }}>
          <p style={{ margin: 0, color: '#666' }}>&copy; 2024 OTT Dashboard. All rights reserved.</p>
        </Footer>
      </Layout>
    </Layout>
  );
};

export default GlobalLayout;
